module.exports = __webpack_public_path__ + "img/why-choose-icon.97278786.png";